module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-c07653d1e23f34f9d71d2d1aed67f14c.png";